module.exports = __webpack_public_path__ + "img/flow3.a6a2214c.png";